import { Component, OnInit, OnDestroy } from '@angular/core';
import { VersionInfoService } from './version-info.service';
import { ServiceVersionsDto } from './version-info.model';
import { NOT_AVAILABLE, PRODUCT_VERSION_APP_NAME } from '../../shared.consts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandingSettingsService } from '../../../settings/branding-settings/proxy/branding-settings.service';
import { BrandingSettingsDto } from '../../../settings/branding-settings/proxy/branding-settings.model';
import { BrandingSettingsHelperService } from '../../services/branding-settings-helper.service';

@Component({
  selector: 'cai-version-info',
  templateUrl: './version-info.component.html',
  standalone: false,
})
export class VersionInfoComponent implements OnInit, OnDestroy {
  serviceVersionsDto: ServiceVersionsDto;
  productVersion: string;
  isDetailsVisible = false;
  loading = true;
  logoUrl: string | null = null;
  constructor(
    private versionInfoService: VersionInfoService,
    private modalService: NgbModal,
    private brandingSettingsService: BrandingSettingsService,
    private brandingSettingsHelper: BrandingSettingsHelperService,
  ) {}

  ngOnInit() {
    this.loadLogo();
    this.versionInfoService.getServiceVersions().subscribe((response) => {
      this.serviceVersionsDto = response;
      this.productVersion =
        this.serviceVersionsDto?.appSetDto?.pods?.find((x) => x?.app === PRODUCT_VERSION_APP_NAME)
          ?.tag ?? NOT_AVAILABLE;

      this.loading = false;
    });

    // Listen for branding updates
    window.addEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  toggleDetails() {
    this.isDetailsVisible = !this.isDetailsVisible;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  ngOnDestroy(): void {
    window.removeEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  private loadLogo(): void {
    this.brandingSettingsService.get().subscribe({
      next: (settings: BrandingSettingsDto) => {
        if (settings.logoBase64 && settings.logoContentType) {
          this.logoUrl = this.brandingSettingsHelper.createDataUrl(
            settings.logoBase64,
            settings.logoContentType,
          );
        }
      },
      error: (err) => {
        console.error('Error loading logo:', err);
      },
    });
  }

  private handleBrandingUpdate(event: Event): void {
    const customEvent = event as CustomEvent<BrandingSettingsDto>;
    if (customEvent.detail?.logoBase64 && customEvent.detail?.logoContentType) {
      this.logoUrl = this.brandingSettingsHelper.createDataUrl(
        customEvent.detail.logoBase64,
        customEvent.detail.logoContentType,
      );
    }
  }
}
